import { retrieveTimeSpan } from '../../service/timestampService';

export const TableTimeSpan = ({
	start,
	end,
	classes,
}: {
	start: string;
	end: string;
	classes?: string;
}) => {
	const classList = `time-tracker-timestamp ${classes ? classes : ''}`;
	const timestamp = retrieveTimeSpan(new Date(start), new Date(end));

	return <p className={classList}>{timestamp}</p>;
};
